import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Main from './Main';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto-mono/300.css';
import '@fontsource/roboto-mono/400.css';
import '@fontsource/roboto-mono/500.css';
import '@fontsource/roboto-mono/700.css';
import { QueryClientProvider } from '@tanstack/react-query';
import useCreateQueryClient from './aceapi/hooks/useCreateQueryClient';
import useToken from './aceapi/hooks/useToken';
import { TokenProvider } from './config/contexts';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function App() {
    const token = useToken();
    const queryClient = useCreateQueryClient();

    return (
        <TokenProvider value={token}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Main />
                    </LocalizationProvider>
                </BrowserRouter>
            </QueryClientProvider>
        </TokenProvider>
    );
}

export default App;
